import { MDSButton, MDSIcon, MDSButtonSlotName, MDSButtonVariant, MDSIconKind } from "@/mds";
import styled from "@emotion/styled";
import { windowModule } from "@/modules/window";

type TProps = {
  openBtnProps: {
    url: string;
    title: string;
  };
};

export const FloatingPreviewActions = ({ openBtnProps }: TProps) => {
  const { url, title } = openBtnProps;

  return (
    <Container>
      <MDSButton
        variant={MDSButtonVariant.Contrast}
        onClick={() => {
          windowModule.openInNewTab({
            url: new URL(url),
          });
        }}
      >
        <MDSIcon slot={MDSButtonSlotName.LeftIcon} kind={MDSIconKind.ExternalLink} /> {title}
      </MDSButton>
    </Container>
  );
};

const Container = styled.section`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing["1"]};
  justify-content: flex-end;
  padding: ${({ theme }) => theme.spacing["0.5"]} ${({ theme }) => theme.spacing["4"]};
`;
